var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHandCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3336 10.0013C15.6336 10.0013 17.5003 8.13464 17.5003 5.83464C17.5003 3.53464 15.6336 1.66797 13.3336 1.66797C11.0336 1.66797 9.16698 3.53464 9.16698 5.83464C9.16698 8.13464 11.0336 10.0013 13.3336 10.0013ZM17.8753 14.668C17.5503 14.3346 17.142 14.168 16.667 14.168H10.8336L9.10031 13.5596L9.37531 12.7763L10.8336 13.3346H13.167C13.4586 13.3346 13.692 13.218 13.8836 13.0263C14.0753 12.8346 14.167 12.6013 14.167 12.343C14.167 11.893 13.9503 11.5846 13.517 11.4096L7.45865 9.16797H5.83365V16.668L11.667 18.3346L18.3586 15.8346C18.367 15.393 18.2003 15.0013 17.8753 14.668ZM4.16698 9.16797H0.820312V18.3346H4.16698V9.16797Z",
    fill: "#C7222A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandCoin);
export default __webpack_public_path__ + "static/media/hand-coin.9e0d79efdd64a5ad98b8da18ec100081.svg";
export { ForwardRef as ReactComponent };